<template>
  <div class="statistics-data">
    <div
      class="statistics-template"
      v-for="(data,index) in datas"
      :key="index"
      @click="goStatistics(data.title,data.data)"
    >
      <p v-text="data.title"></p>
      <p>
        {{data.data}}
        <span>名</span>
      </p>
      <p>查看详情</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      datas: [
        // { title: "注册人数统计", data: "" },
        // { title: "党员人数统计", data: "" }
      ],
    };
  },
  name: "statisticsData",
  props: {
    title: String,
    headImgs:Array
  },
  methods: {
    goStatistics(index,data) {      
      switch (index) {
        case '注册人数统计':
          this.$router.push({
            path: "dataQuery/loginBody",
            query: { title: "注册人数统计" }
          });
          break;
        case '党员人数统计':
          this.$router.push({
            path: "dataQuery/partyBody",
            query: { title: "党员人数统计" ,allPeople:data}
          });
          break;
        default:
          break;
      }
    },
  },
  mounted(){
    // console.log(this.headImgs);
    this.datas = this.headImgs   
    // this.headImgs.filter((item,index)=>{    
    //   console.log(item.title);
    //   console.log(this.datas[index].title);
        
    //   if(item.title==this.datas[index].title){
        
        
    //     // this.datas[index].data=item.data
    //   }
    // }) 
    
    
    // console.log('asd',this.headImgs);
    
  },
};
</script>
<style lang='scss' scoped>
.statistics-data {
  .statistics-template {
    p {
      &:nth-child(1) {
        font-size: 0.28rem;
      }
      &:nth-child(2) {
        span {
          font-size: 0.28rem;
        }
        font-size: 0.54rem;
      }
      &:nth-child(3) {
        font-size: 0.24rem;
      }
    }
    &:nth-child(odd) {
      margin-right: 0.2rem;
      background-image: linear-gradient(113deg, #05baff 0%, #199eff 100%);
    }
    &:nth-child(even) {
      background-image: linear-gradient(1deg, #f9b94d 0%, #fdcb76 100%);
    }
    color: #fff;

    border-radius: 0.08rem;
    padding: 0.2rem;
  }
  font-size: 0.3rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(3.45rem, 1fr));
  grid-template-rows: auto 1fr;
  background: #fff;
  padding: 0.2rem;
}
</style>